<script lang="ts">
    export let progress: number;
    let progressMaxValue = 100;
</script>

<progress
    class="gw-ig-story-modal-progress"
    max={progressMaxValue}
    value={progress}
/>

<style>
    .gw-ig-story-modal-progress {
        width: 100%;
        height: var(--gw-vp-slider-track-height);
        transform: translateY(-50%);
        border: none;
        border-radius: calc(var(--gw-vp-slider-track-height) / 2);
        background: var(--gw-vp-slider-progress-color);
        color: var(--gw-vp-slider-buffered-color);
        appearance: none;
    }

    /* PROGRESS ELEMENT FOR CHROME */

    .gw-ig-story-modal-progress::-webkit-progress-value {
        min-width: var(--gw-vp-slider-track-height);
        transition: width 0.06s linear;
        border-radius: calc(var(--gw-vp-slider-track-height) / 2);
        background: currentcolor;
    }

    .gw-ig-story-modal-progress::-webkit-progress-bar {
        transition: width 0.06s linear;
        background-color: transparent;
    }

    /* PROGRESS ELEMENT FOR FIREFOX */
    .gw-ig-story-modal-progress::-moz-progress-bar {
        border-radius: calc(var(--gw-vp-slider-track-height) / 2);
        background: currentcolor;
    }
</style>
